import { keepPreviousData } from '@tanstack/vue-query';
import type { ValuationForm, ValuationBody } from '#shared/valuation/types';
import type { ContactSellerBody, ContactSellerForm } from '#shared/contact/types';
import type { SearchPropertyType } from '#shared/property/search-criteria';

export function useValuation() {
  return useMutation({
    mutationFn: (valuationForm: ValuationForm) => {
      const body: ValuationBody = {
        valuationForm,
        marketingTracking: getMarketingTracking(),
      };
      return $fetch(`/api/valuation`, {
        body,
        method: 'POST',
      });
    },
  });
}

export function useValuationProperties(propertyType?: MaybeRef<SearchPropertyType>) {
  const propertyTypeRef = ref(propertyType);
  return useQuery({
    queryKey: [`valuation-properties-${propertyTypeRef.value}`],
    placeholderData: keepPreviousData,
    queryFn: () => {
      return $fetch(`/api/valuation`, {
        method: 'GET',
        query: {
          propertyType: propertyTypeRef.value,
        },
      });
    },
    retry: 0,
  });
}

export function useValuationContact() {
  return useMutation({
    mutationFn: (contactForm: ContactSellerForm) => {
      const body: ContactSellerBody = {
        contactForm,
        marketingTracking: getMarketingTracking(),
      };
      return $fetch(`/api/valuation/contact`, {
        body,
        method: 'POST',
      });
    },
  });
}
